import { initProjectCadenceApp } from 'ee/iterations';

initProjectCadenceApp();
